import dayjs, { Dayjs } from 'dayjs';
import { useState, useEffect } from 'react';
import showSnackbar from 'utils/showSnackbar';

const MAX_MONTHS_DIFF = 2;

export default function useDateRangeDialogLogic(
  onClose: () => void,
  onApply: (startDate: string, endDate: string) => void,
) {
  const [startDate, setStartDate] = useState<Dayjs | null>(null);
  const [endDate, setEndDate] = useState<Dayjs | null>(dayjs());
  const [maxStartDate, setMaxStartDate] = useState<Dayjs | null>(null);
  const [maxEndDate, setMaxEndDate] = useState<Dayjs | null>(null);

  const handleApply = () => {
    onApply(startDate.toISOString(), endDate.toISOString());
    handleClose();
  };

  const handleReset = () => {
    setStartDate(null);
    setEndDate(null);
    setMaxStartDate(null);
    setMaxEndDate(null);
  };

  const handleClose = () => {
    handleReset();
    onClose();
  };

  const handleStartDateChange = (newDate: Dayjs | null) => {
    if (newDate?.isValid()) {
      setMaxEndDate(newDate.add(MAX_MONTHS_DIFF, 'month'));
    }

    setStartDate(newDate);
  };

  const handleEndDateChange = (newDate: Dayjs | null) => {
    if (newDate?.isValid()) {
      setMaxStartDate(newDate.subtract(MAX_MONTHS_DIFF, 'month'));
    }

    setEndDate(newDate);
  };

  useEffect(() => {
    if (startDate && endDate) {
      const diff = Math.abs(startDate.diff(endDate, 'month'));

      if (diff > MAX_MONTHS_DIFF) {
        showSnackbar(
          `O período não pode ser maior que ${MAX_MONTHS_DIFF} meses.`,
          'warning',
        );
        setEndDate(null);
      }
    }
  }, [startDate, endDate]);

  return {
    startDate,
    endDate,
    maxStartDate,
    maxEndDate,
    handleApply,
    handleReset,
    handleClose,
    handleStartDateChange,
    handleEndDateChange,
  };
}
